import { apiFetch, httpError } from '../services/apiFetch';

const API_URL = import.meta.env.VITE_API_URL;

export async function fetchExpensesByJob(jobId) {
    const res = await apiFetch(`${API_URL}/api/Expense/GetExpensesByJob/${jobId}`, { method: 'GET' });
    if (!res.ok) throw await httpError(res, 'Failed to fetch expenses');
    return res.json();
}

export async function createExpense(body) {
    const res = await apiFetch(`${API_URL}/api/Expense/CreateExpense`, {
        method: 'POST',
        body: JSON.stringify(body),
    });
    if (!res.ok) throw await httpError(res, 'Failed to create expense');
    return res.json();
}

// Scan-driven create flow, step 2. Body carries the normal expense fields
// plus the blob metadata echoed back from scanReceipt — the server copies
// the pending blob into its final home and inserts the Receipt row in one
// action, so the client never has to orchestrate the happy path.
export async function createExpenseFromReceipt(body) {
    const res = await apiFetch(`${API_URL}/api/Expense/CreateExpenseFromReceipt`, {
        method: 'POST',
        body: JSON.stringify(body),
    });
    if (!res.ok) throw await httpError(res, 'Failed to create expense from receipt');
    return res.json();
}

export async function updateExpense(id, body) {
    const res = await apiFetch(`${API_URL}/api/Expense/UpdateExpense/${id}`, {
        method: 'POST',
        body: JSON.stringify(body),
    });
    if (!res.ok) throw await httpError(res, 'Failed to update expense');
    return res.json();
}

export async function deleteExpense(id) {
    const res = await apiFetch(`${API_URL}/api/Expense/DeleteExpense/${id}`, { method: 'POST' });
    if (!res.ok) throw await httpError(res, 'Failed to delete expense');
}

// Pre-save duplicate check. Returns an array of likely-duplicate matches
// (possibly empty) so the create/edit form can warn before committing. Pass
// excludeId when editing so the row doesn't match itself. Advisory only.
export async function checkExpenseDuplicates({ amount, date, supplier, excludeId }) {
    const params = new URLSearchParams({ amount: String(amount), date });
    if (supplier) params.set('supplier', supplier);
    if (excludeId != null) params.set('excludeId', String(excludeId));
    const res = await apiFetch(`${API_URL}/api/Expense/CheckDuplicates?${params}`, { method: 'GET' });
    if (!res.ok) throw await httpError(res, 'Failed to check for duplicates');
    return res.json();
}

// Clears the OCR-set "possible duplicate" flag on a scanned expense.
export async function dismissExpenseDuplicate(id) {
    const res = await apiFetch(`${API_URL}/api/Expense/DismissDuplicate/${id}`, { method: 'POST' });
    if (!res.ok) throw await httpError(res, 'Failed to dismiss duplicate flag');
}
